import { render } from "./ResourceResultsTable.vue?vue&type=template&id=fb9b9a28"
import script from "./ResourceResultsTable.vue?vue&type=script&lang=ts"
export * from "./ResourceResultsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script